// extracted by mini-css-extract-plugin
export default {"payment_button":"PaymentButton_payment_button__NR-Ev"};